import { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuth } from "./auth/AuthContext";
import { AuditLogsPage } from "./pages/AuditLogsPage";
import { AutoPlanningPage } from "./pages/AutoPlanningPage";
import { BranchesPage } from "./pages/BranchesPage";
import { CustomersPage } from "./pages/CustomersPage";
import { CalendarPage } from "./pages/CalendarPage";
import { DashboardPage } from "./pages/DashboardPage";
import { LoginPage } from "./pages/LoginPage";
import { SettingsPage } from "./pages/SettingsPage";
import { InstructorsPage } from "./pages/InstructorsPage";
import InstructorMobilePage from "./pages/InstructorMobilePage";
import LessonReportsPage from "./pages/LessonReportsPage";
import ReportsPage from "./pages/ReportsPage";
import StudentMobilePage from "./pages/StudentMobilePage";
import { StudentsPage } from "./pages/StudentsPage";
import { SystemStatusPage } from "./pages/SystemStatusPage";
import { UsersPage } from "./pages/UsersPage";
import { VehiclesPage } from "./pages/VehiclesPage";

/** Egitmen yonetim ekranlarina girmez; kendi operasyon ekranina yonlenir. */
function ManagementOnly({ children }: { children: ReactElement }) {
  const { session } = useAuth();
  const role = session?.user?.role;
  if (role === "instructor") {
    return <Navigate to="/calendar" replace />;
  }
  return children;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/m/instructor" element={<InstructorMobilePage />} />
        <Route path="/m/student" element={<StudentMobilePage />} />
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ManagementOnly><DashboardPage /></ManagementOnly>} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/students" element={<StudentsPage />} />
          <Route path="/instructors" element={<ManagementOnly><InstructorsPage /></ManagementOnly>} />
          <Route path="/vehicles" element={<ManagementOnly><VehiclesPage /></ManagementOnly>} />
          <Route path="/vehicle-tracking" element={<Navigate to="/dashboard" replace />} />
          <Route path="/auto-planning" element={<AutoPlanningPage />} />
          <Route path="/lesson-reports" element={<LessonReportsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/settings/branches" element={<BranchesPage />} />
          <Route path="/audit-logs" element={<AuditLogsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/system-status" element={<SystemStatusPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
